export const baseURL = "https://ferrywheel.tokchat.duckdns.org/";
export const adminBaseURL = "https://admin.tokchat.duckdns.org/";
export const key = "5TIvw5cpc0";
